<p-card>
	<div class="p-grid button-grid">
		<div class="p-col-4">
			<button pButton 
					class="p-button p-button-primary p-button-rounded" 
					[icon]="('pi ' + ((!loadingDirection('BACKWARD')) ? 'pi-arrow-left' : 'pi-spin pi-spinner'))"
					[disabled]="!src.hasNext('BACKWARD') || isLoading"
					pTooltip="Back"
					(click)="getNext('BACKWARD')"></button>
		</div>
		<div class="p-col-4 p-text-center">
			<span *ngIf="isLoading && src.currentIndex === -1">Loading Details</span>
			<span *ngIf="(!isLoading || src.currentIndex > -1) && src.currentItem">{{src.currentIndex + 1}} of {{src.totalElements}}</span>
			<span *ngIf="!isLoading && src.currentItem === null && !src.hasNoList">Invalid Results</span>
			<span *ngIf="!isLoading && src.hasNoList">No Items</span>
			<button pButton label="Back to list" class="p-button p-button-link" (click)="backToListClicked.emit()"></button>
		</div>
		<div class="p-col-4 p-text-right">
			<button pButton
					class="p-button p-button-primary p-button-rounded" 
					[icon]="('pi ' + ((!loadingDirection('FORWARD')) ? 'pi-arrow-right' : 'pi-spin pi-spinner'))"
					[disabled]="!src.hasNext('FORWARD') || isLoading"
					pTooltip="Next"
					(click)="getNext('FORWARD')"></button>
		</div>
	</div>
</p-card>